import { ApplicationStore } from "src/store";

export const getConditionalRebatesType = (state: ApplicationStore) =>
    state.account?.integration_settings?.Financing?.conditional_rebates ?? "none";

export const isConditionalRebatesEnabled = (state: ApplicationStore) =>
    (state.account?.integration_settings?.Financing?.conditional_rebates ?? "none") !== "none";

export const isConditionalRebatesDataDriven = (state: ApplicationStore) =>
    (state.account?.integration_settings?.Financing?.conditional_rebates ?? "none") === "data-driven";
